import {defaultBreadcrumbs, ScreenProp} from 'src/app/models'

export const PerusahaanScreen: Record<string, ScreenProp> = {
  PERUSAHAAN_LIST: {
    PATH: '/administration/setup-perusahaan',
    TITLE: 'Perusahaan',
    TITLE_ALT: 'Perusahaan',
    breadcrumbs: defaultBreadcrumbs,
  },
  PERUSAHAAN_ADD: {
    PATH: '/administration/setup-perusahaan/add',
    TITLE: 'Buat Perusahaan',
    TITLE_ALT: 'Buat Perusahaan',
    breadcrumbs: defaultBreadcrumbs,
  },
  PERUSAHAAN_EDIT: {
    PATH: '/administration/setup-perusahaan/edit/:id',
    TITLE: 'Edit Perusahaan',
    TITLE_ALT: 'Edit Perusahaan',
    breadcrumbs: defaultBreadcrumbs,
  },
  PERUSAHAAN_DETAIL: {
    PATH: '/administration/setup-perusahaan/detail/:id',
    TITLE: 'Detail Perusahaan',
    TITLE_ALT: 'Perusahaan',
    breadcrumbs: defaultBreadcrumbs,
  },
}
